<app-breadcrumb *ngIf="!disableBreadcrumb && name==='Szkolenia'" [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Lista'"></app-breadcrumb>
<app-breadcrumb *ngIf="!disableBreadcrumb && name==='Egzaminy'" [master]="'Rejestracje'" [parentName]="'Egzaminy'" [name]="'Lista'"></app-breadcrumb>
<div class="meeting-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="meeting-list-filters">
    <ng-container *ngIf="!disableFilters">
      <app-dict
        *ngIf="displayedColumns?.includes('examType') && null === missingExamKeys"
        [multiple]="false"
        label="Rodzaj"
        class="meeting-list-filter"
        dictType="meeting_type"
        [onlyKeys]="[MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM]"
        [(ngModel)]="initialFilters.type" name="type"
      ></app-dict>

      <app-dict
        *ngIf="!displayedColumns?.includes('examType')"
        [multiple]="false" [dictType]="'meeting_type'"
        [onlyKeys]="MEETING_TYPES"
        [label]="'Rodzaj Szkolenia'" class="meeting-list-filter"
        [(ngModel)]="initialFilters.type" name="type"
      ></app-dict>

      <app-dict-insurance-companies
        *ngIf="displayedColumns?.includes('insuranceCompany')" [multiple]="true"
        label="TU" class="meeting-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      ></app-dict-insurance-companies>

      <app-datepicker
        *ngIf="displayedColumns?.includes('startsAt')"
        class="meeting-list-filter"
        label="Data rozpoczęcia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$startsAt" name="gte$startsAt"
      ></app-datepicker>

      <app-datepicker
        *ngIf="displayedColumns?.includes('startsAt')"
        class="meeting-list-filter"
        label="Data rozpoczęcia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$endsAt" name="lte$endsAt"
      ></app-datepicker>

      <app-dict
        *ngIf="displayedColumns?.includes('status')" [multiple]="true"
        label="Status" class="meeting-list-filter"
        dictType="meeting_status"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>

      <app-dict
        *ngIf="displayedColumns?.includes('examType') && null === missingExamKeys"
        [multiple]="true" label="Rodzaj egzaminu" class="meeting-list-filter"
        dictType="meeting_exam_type"
        [(ngModel)]="initialFilters.in$examType" name="in$examType"
      ></app-dict>

      <app-dict
        *ngIf="displayedColumns?.includes('place')" [multiple]="true"
        label="Typ" class="meeting-list-filter"
        dictType="meeting_place"
        [(ngModel)]="initialFilters.in$place" name="in$place"
      ></app-dict>

      <app-dict
        *ngIf="displayedColumns?.includes('leader')" [multiple]="true"
        label="Prowadzący szkolenie"
        class="meeting-list-filter"
        dictType="meeting_leader"
        [(ngModel)]="initialFilters.in$leader" name="in$leader"
      ></app-dict>

      <mat-form-field class="meeting-list-filter meeting-list-filter-long">
        <mat-label>Adres</mat-label>
        <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">
      </mat-form-field>

<!--      <app-dict
        [multiple]="false" [dictType]="'address_state'"
        [label]="'Województwo'" class="meeting-list-filter"
        [(ngModel)]="initialFilters.state" name="state"
      ></app-dict>-->

    </ng-container>
  </form>

  <div class="meeting-list-buttons" *ngIf="!disableFilters">
    <button *ngIf="(userPermissions | async).meeting.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).meeting.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="meetings">
    <ng-container matColumnDef="meeting">
      <th mat-header-cell *matHeaderCellDef> {{tableFor}} </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="!dialogView && name!=='Szkolenia'" class="default-link" [routerLink]="['/egzaminy-szkolenia/szczegoly', element.uuid]">
          {{element.type.name}}
        </a>
        <a *ngIf="!dialogView && name==='Szkolenia'" class="default-link" [routerLink]="['/szkolenie/szczegoly', element.uuid]">
          {{element.type.name}}
        </a>
        <ng-container *ngIf="dialogView">
          {{element.type.name}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="logo">
      <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.insuranceCompany?.imageLocation" src="/rest/crm/insuranceCompany/{{element.insuranceCompany?.id}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="!dialogView" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany?.id]">
          {{element.insuranceCompany?.name}}
        </a>
        <ng-container *ngIf="dialogView">
          {{element.insuranceCompany?.name}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="insuranceCompanyType">
      <th mat-header-cell *matHeaderCellDef> Typ TU </th>
      <td mat-cell *matCellDef="let element">
        {{element.insuranceCompany?.type?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="startsAt">
      <th mat-header-cell *matHeaderCellDef> Data rozpoczęcia </th>
      <td mat-cell *matCellDef="let element">
        {{element.startsAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="examType">
      <th mat-header-cell *matHeaderCellDef> Rodzaj egzaminu </th>
      <td mat-cell *matCellDef="let element">
        {{element.examType?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="place">
      <th mat-header-cell *matHeaderCellDef> Typ </th>
      <td mat-cell *matCellDef="let element">
        {{element.place?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="linkOrAddress">
      <th mat-header-cell *matHeaderCellDef> Link/Adres </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.link">
          <a target="_blank" class="default-link" [href]="element.link">Link</a>
        </ng-container>

        <ng-container *ngIf="element.address">
          <app-table-address [address]="$any(element.address)"></app-table-address>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="limitOfPeople">
      <th mat-header-cell *matHeaderCellDef> Liczba miejsc </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.limitOfPeople">
          {{element.placesLeft}}/{{element.limitOfPeople}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef> Temat </th>
      <td mat-cell *matCellDef="let element">
        {{element.subject}}
      </td>
    </ng-container>

    <ng-container matColumnDef="leader">
      <th mat-header-cell *matHeaderCellDef> Prowadzący szkolenie </th>
      <td mat-cell *matCellDef="let element">
        {{element.leader?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button color="accent" (click)="selectedMeeting.emit(element)"><mat-icon>done</mat-icon> Wybierz</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
